import React, { Component } from 'react';
import { Icon, Dropdown, Menu, Form, Input, Button } from 'antd';
import dropdown_white from '../../Images/Icons/dropdown_white.svg';
import hide from '../../Images/Icons/hide.svg';
import show from '../../Images/Icons/show.svg';
import resetPassword from '../../Images/Icons/reset-password.svg';
import logout from '../../Images/Icons/logout.svg';

const UserDropdown = Form.create()(
  class extends Component {
    state = {
      showDropdown: false,
      showReset: false,
      newpasswordHidden: true,
      currentPasswordHidden: true,
      confirmPasswordHidden: true,
    };

    // handle the form submit
    handleSubmit = (e) => {
      e.preventDefault();
      const { updateUserDetails, form } = this.props;
      form.validateFields((err, values) => {
        if (!err) {
          updateUserDetails({
            data: values,
            callback: () => {
              this.setState({
                showDropdown: false,
                showReset: false,
              });
            },
          });
        }
      });
    };

    handleCancel = () => {
      this.setState({
        showReset: false,
        showDropdown: false,
      });
    };

    validatePassword = (rule, value, callback) => {
      const { form } = this.props;
      const { getFieldValue } = form;
      const newPassword = getFieldValue('newPassword');
      if (value) {
        if (value === newPassword) {
          callback();
        } else {
          callback('Enter confirm password');
        }
      } else {
        callback('Enter confirm password');
      }
    };

    render() {
      const { userDetails, logoutUser, form } = this.props;
      const { getFieldDecorator } = form;
      const {
        showDropdown,
        showReset,
        newpasswordHidden,
        currentPasswordHidden,
        confirmPasswordHidden,
      } = this.state;
      const menu = (
        <Menu className="userOptionsContainer">
          <span className="dropdownSubHeading">User options</span>
          {/* <Menu.Item onClick={() => {
					this.setState({ showReset: true });
				}} key="0">
					<img src={resetPassword} style={{ height: '15px', marginRight: '10px' }} />
					Reset Password
				</Menu.Item> */}
          <Menu.Item
            key="1"
            onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              logoutUser();
            }}
          >
            <img
              src={logout}
              style={{
                height: '15px',
                marginRight: '10px',
              }}
            />
            Logout
          </Menu.Item>
        </Menu>
      );
      return (
        <Dropdown
          overlayClassName="overlayClassName"
          getPopupContainer={() =>
            document.getElementById('userDropdownButton')
          }
          overlay={
            showReset ? (
              <div className="userDropdownContainer">
                <span className="dropdownSubHeading">
                  <span
                    className="arrowStyles flaticon-arrow"
                    onClick={() => {
                      this.setState({
                        showReset: false,
                      });
                    }}
                  />
                  Reset Password
                </span>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Item className="loginFormField dropdownFormField">
                    <span className="loginLabel">Current Password</span>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Enter current password',
                        },
                      ],
                    })(
                      <Input
                        type={currentPasswordHidden ? 'password' : 'text'}
                        autoComplete="off"
                        placeholder="Enter current password"
                        suffix={
                          <Icon
                            component={() => (
                              <img
                                src={currentPasswordHidden ? hide : show}
                                style={{
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                onClick={(e) =>
                                  this.setState({
                                    currentPasswordHidden:
                                      !currentPasswordHidden,
                                  })
                                }
                              />
                            )}
                          />
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item className="loginFormField dropdownFormField">
                    <span className="loginLabel">New Password</span>
                    {getFieldDecorator('newPassword', {
                      rules: [
                        {
                          required: true,
                          message: 'Enter new password',
                        },
                      ],
                    })(
                      <Input
                        type={newpasswordHidden ? 'password' : 'text'}
                        autoComplete="off"
                        placeholder="Enter new password"
                        suffix={
                          <Icon
                            component={() => (
                              <img
                                src={newpasswordHidden ? hide : show}
                                style={{
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                onClick={(e) =>
                                  this.setState({
                                    newpasswordHidden: !newpasswordHidden,
                                  })
                                }
                              />
                            )}
                          />
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item className="loginFormField dropdownFormField">
                    <span className="loginLabel">Confirm Password</span>
                    {getFieldDecorator('confirm', {
                      rules: [
                        // { required: true, message: "Enter confirm password" },
                        {
                          validator: this.validatePassword,
                        },
                      ],
                    })(
                      <Input
                        type={confirmPasswordHidden ? 'password' : 'text'}
                        autoComplete="off"
                        placeholder="Enter confirm password"
                        suffix={
                          <Icon
                            component={() => (
                              <img
                                src={confirmPasswordHidden ? hide : show}
                                style={{
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                onClick={(e) =>
                                  this.setState({
                                    confirmPasswordHidden:
                                      !confirmPasswordHidden,
                                  })
                                }
                              />
                            )}
                          />
                        }
                      />
                    )}
                  </Form.Item>
                  <div className="dropdownFooter">
                    <Button
                      className="linkButton"
                      type="link"
                      onClick={this.handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="primaryButton"
                      htmlType="submit"
                      type="primary"
                      onClick={this.handleSubmit}
                      style={{
                        marginLeft: '5px',
                      }}
                    >
                      Reset
                    </Button>
                  </div>
                </Form>
              </div>
            ) : (
              menu
            )
          }
          visible={showDropdown}
          trigger={['click']}
          onVisibleChange={(visible) => {
            this.setState({
              showDropdown: visible,
              showReset: false,
            });
          }}
          className="userNameDropdown"
        >
          <span id="userDropdownButton">
            <span className="profilePictureContainer">
              {userDetails &&
                userDetails.userName &&
                userDetails &&
                userDetails.userName.charAt(0)}
            </span>
            <span className="userName">
              {userDetails && userDetails.userName}
            </span>
            <Icon
              className="dropdownIcon"
              component={() => (
                <img
                  src={dropdown_white}
                  style={{
                    height: '8px',
                    width: '8px',
                  }}
                />
              )}
            />
          </span>
        </Dropdown>
      );
    }
  }
);

export default UserDropdown;
